import { NAMESPACE } from "./_Namespace";

export class Service<TService>
{
    public static classNamespace = NAMESPACE + "Service";
    public static className = "Service";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    instance?: TService;
}